/* eslint-disable no-unused-vars */
export enum PlanTier {
  Free,
  Essentials = 3,
  Enhanced = 1,
  Ultimate
}

export enum PlanType {
  None,
  Braintree,
  Apple,
  AppleRenewing,
  Stripe,
  PlayStore,
  Promotional
}

export enum DuplicateSubscriptionError {
  None,
  BraintreeBraintree,
  BraintreeApple,
  AppleApple
}

export enum PlanStatus {
  None,
  Active,
  Canceled
}

export enum PayForCoparentSponsorshipStatus {
  Eligible = 1,
  HasOpenSponsorship,
  NotMatched,
  NoValidSubscription
}

export enum PayForCoparentRecipientStatus {
  NoSponsorship = 1,
  SponsorshipNotAccepted,
  SponsorshipAccepted,
  EntitlementGranted
}

// Mirrors backend TP.Core.Models.Pfc.PfcSponsorshipEntitlementStatus.
export enum PfcSponsorshipEntitlementStatus {
  Granted = 1,
  Pending = 2
}

export enum CreateCustomerPortalSessionError {
  ServerError,
  StripeError,
  NoSubscription,
  MigrationInProgress
}

export enum ChangeEmailError {
  Unknown,
  EmailAlreadyInUse,
  EmailMatchesExisting,
  InvalidEmailFormat,
  EmailMissingOrEmpty
}

// Mirrors backend EnableMfaSmsError returned by /api/myaccount/enablemfasms.
export enum EnableMfaSmsError {
  Unknown,
  PhoneNotVerified,
  TooManyAttempts,
  AlreadyEnabled,
  InvalidPhoneNumber
}

export enum ChangePasswordError {
  ServerError,
  PasswordIncorrect,
  UnknownPasswordFormat
}
